import { Clear, Create, Done } from "@mui/icons-material"
import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState } from "react"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import EdicaoAutomacao from "../EdicaoAutomacao/EdicaoAutomacao"

const CardAutomacao = ({ automacao, idCentral, moveCard, findCard }) => {
    const { descricao, id, visivel } = automacao

    const [openAutomacao, setOpenAutomacao] = useState(false)

    const editAutomacao = () => {
        setOpenAutomacao(true)
    }

    return (
        <Grid
            xs={12}
            sx={{ alignItems: 'center', paddingTop: '5px' }}
            container
        >
            {openAutomacao &&
            <EdicaoAutomacao openAutomacao={openAutomacao} setOpenAutomacao={setOpenAutomacao} idToEdit={id} idCentral={idCentral} />
            }
            <Grid container xs sx={{ border: '1px solid grey', padding: '10px', borderRadius: '5px', alignItems: 'center' }}>
                <Grid md={10}>
                    <Grid container xs={7} sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={1.5}>
                            <Typography fontSize="13px" fontWeight='400' >Descrição: </Typography>
                        </Grid>
                        <Grid xs={12} md={10}>
                            <OneInput
                                defaultValue={descricao}
                                readOnly
                                name={"descricao"}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={1.5}>
                    <Grid xs={7} container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md>
                            {visivel ? (<Done sx={{ color: "green" }}/>) : (<Clear sx={{ color: "red" }}/>)}
                        </Grid>
                        <Grid xs={12} md={9}>
                            <Typography fontSize="13px" fontWeight='400' >Visível </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md>
                    <Grid xs={1} container sx={{ alignItems: 'center' }}>
                        <Create sx={{ cursor: 'pointer', fontSize: '18px' }} onClick={() => { editAutomacao() }}/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardAutomacao
